var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 336,
    viewBox: "0 0 512 336",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#464655",
    d: "M0 62.069v211.862L141.241 168z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.621.275l158.897 123.587H512V9.103a8.829 8.829 0 0 0-8.828-8.828H70.621z",
    fill: "#FF4B55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.621 335.725l158.897-123.587H512v114.759a8.829 8.829 0 0 1-8.828 8.828H70.621z",
    fill: "#41479B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.889.276H8.828A8.828 8.828 0 0 0 0 9.103v36.21L154.974 168 0 290.69v36.206a8.829 8.829 0 0 0 8.828 8.828h48.056L224.147 203.31H512v-70.62H224.148L56.889.276z",
    fill: "#73AF00"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "M85.333.276H56.889L224.148 132.69H512v-17.656H230.291z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFE15A",
    d: "M0 45.313v22.518L126.53 168 0 268.173v22.517L154.974 168z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "M224.147 203.31L56.884 335.724h28.445l144.96-114.758H512V203.31z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZa);
export default __webpack_public_path__ + "static/media/za.3aba8a56e52ad0fe15432a35b5b35ee9.svg";
export { ForwardRef as ReactComponent };